import { SegmentInfo, SegmentLoad } from './types';

// The HGL colours a segment red at or above its rating (PCRoute.colourRouteByPressure), so the check does too.
const OVER_PRESSURE_UTILISATION = 1;

interface RatedPipe {
  pipeId: string;
  pressureRating: number;
}

export interface SegmentCheckInput {
  // One per route point, stope first, in kPa.
  pressures: number[];
  // One per segment: the pipe the segment is priced on.
  pipes: RatedPipe[];
  segments: SegmentInfo[];
  offsetKpa: number;
  excludedPipeIds: string[];
}

// Both ends of every segment against the segment's own pipe. A node -> twin join is a pressure discontinuity whose
// ends are already checked by the real segments either side of it, so it is skipped.
export const segmentLoads = ({
  pressures,
  pipes,
  segments,
  offsetKpa,
  excludedPipeIds,
}: SegmentCheckInput): SegmentLoad[] => segments.flatMap((segment, index) => {
  if (segment.isTwinJoin) return [];
  const { pipeId, pressureRating } = pipes[index];
  const pressureKpa = Math.max(pressures[index] ?? 0, pressures[index + 1] ?? 0);
  const envelopeKpa = pressureKpa + (excludedPipeIds.includes(pipeId) ? 0 : offsetKpa);
  return [{
    index,
    ownerSpoolId: segment.ownerSpoolId,
    kind: segment.kind,
    pipeId,
    pressureKpa,
    envelopeKpa,
    ratingKpa: pressureRating,
    overpressured: envelopeKpa / pressureRating >= OVER_PRESSURE_UTILISATION,
  }];
});
